// Normalizes a CBRE invoice group built by groupRows() in
// src/components/CBREInvoice.js: { totals: { invoiceAmount, salesTax, totalAmount } }.
// CBRE's source workbook has no WHT figure and no service/reimbursement split
// today — everything is a single passthrough "Invoice Amount" line.
import { LINE_CATEGORIES, makeLine } from "../lineCategories";
import { classifyCbreInvoice } from "../cbreGst";

export function normalizeCbreInvoice(invoice) {
  const totals = invoice.totals || {};
  const invoiceAmount = Number(totals.invoiceAmount || 0);
  const gstAmount = Number(totals.salesTax || 0);
  const grossAmount = Number(totals.totalAmount || (invoiceAmount + gstAmount));

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "CBRE invoice amount", amount: invoiceAmount, sourceField: "totals.invoiceAmount" }),
    makeLine({ category: LINE_CATEGORIES.GST, description: "Sales tax", amount: gstAmount, sourceField: "totals.salesTax" })
  ];

  // Services carry 16% GST and supplies 18%; which one this invoice is comes from its own
  // tax / amount, and is kept on the snapshot so the rate that applied is on record.
  const classification = classifyCbreInvoice(invoice.lineItems, totals);

  return {
    meta: { gstKind: classification.type, gstRatePercent: classification.percent },
    lines,
    serviceChargeSubtotal: invoiceAmount,
    invoiceAmount,
    gstAmount,
    grossAmount,
    recoveryBase: null,
    recoveryAddBack: null
  };
}
